import { ENDPOINTS } from 'config/endpoints';
import client from 'utils/clients/client';
import { useInfiniteQuery } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import { Request } from 'crono-fe-common/types/request';
import { ResponsePaginated } from 'crono-fe-common/types/response';
import { List } from 'crono-fe-common/types/list';
import { IListSearchParams } from './useSearchLists';
import { Constants } from 'crono-fe-common/constants/constants';

export default function useSearchListsInfinite(
  listParams: IListSearchParams,
  enabled = true,
) {
  const getRequest = (offset = 0) => {
    const request: Request = {
      url: `${ENDPOINTS.list.search}`,
      config: {
        method: 'post',
        data: { data: { ...listParams, offset } },
      },
    };
    return request;
  };

  const requestConfig = {
    queryKey: [
      ENDPOINTS.list.search,
      listParams.prospectId,
      listParams.accountId,
      JSON.stringify(listParams),
    ],
    queryFn: ({ pageParam }: { pageParam?: number }) =>
      client(getRequest(pageParam)),
    getNextPageParam: (
      lastPage: ResponsePaginated<List[]>,
      pages: ResponsePaginated<List[]>[],
    ) => {
      if (!lastPage.data.data) {
        return undefined;
      }
      const howManyLoaded = pages.reduce(
        (sum, page) => sum + page.data.data.length,
        0,
      );
      const checkIfHasNextPage =
        lastPage.data.data.length === 0 ||
        lastPage.data.data.length <
          (listParams.limit ?? Constants.defaultLimit);
      if (checkIfHasNextPage) {
        return undefined;
      }
      return howManyLoaded;
    },
    staleTime: 5 * 60 * 1000,
    enabled,
  };

  const { data, ...rest } = useInfiniteQuery<
    ResponsePaginated<List[]>,
    CronoError
  >(requestConfig);

  return { data, ...rest };
}
